import { authHeader,logout, handleResponse } from '../helpers';
import Vue from 'vue';


export const proizvodService = {
    load,loadAll,save,remove,loadPreteklaSezona
    
};

function load(sezona,pridelovalecid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/proizvod/?sezona=${sezona}&pridelovalecid=${pridelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(proizvod => {
            // login successful if there's a jwt token in the response
            
            return proizvod;
        });
}

function loadPreteklaSezona(sezona,pridelovalecid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/proizvod/preteklasezona/?sezona=${sezona}&pridelovalecid=${pridelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(proizvod => {
            // login successful if there's a jwt token in the response
            
            return proizvod;
        });
}


function save(proizvod) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(proizvod)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/proizvod`, requestOptions).then(handleResponse);
}


function remove(proizvod) {
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(proizvod)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/proizvod`, requestOptions).then(handleResponse);
}

function loadAll(sezona){
  const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


     return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/proizvodi/?sezona=${sezona}`, requestOptions)
        .then(handleResponse)
        .then(proizvod => {
            // login successful if there's a jwt token in the response
            
            return proizvod;
        });
}

function loadLastYear(gerk,status){
    //in tu lahko napišem pravila ali pa jih enostavno potegnem iz baze preko api-ja
    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/proizvod/?sezona=${sezona}&pridelovalecid=${pridelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(proizvod => {
            // login successful if there's a jwt token in the response
            
            return proizvod;
        });

}
